<template>
  <!-- Page Content -->
  <div id='page-wrapper'>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='row'>
        <div class='col-lg-12'>
          <h1 class='page-header'>أسعار الأصناف</h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class='row'>
        <div class='col-lg-12'>
          <div class='panel panel-default'>
            <div class='panel-heading'>
              هنا يتم عرض جميع أسعار الأصناف لكل فرع
            </div>
            <br>
            <div class='form-group col-lg-12 col-sm-12'>
              <div class="form-group input-group">
                <span class="input-group-addon">الفرع:</span>
                <select style="padding: 0px" @change='GetData()' class="form-control" v-model="branch">
                  <option v-for="item in branches" :key="item.id" v-bind:value="item.id">
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
            <!-- /.panel-heading -->
            <div class='panel-body'>
              <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                <thead>
                  <tr>
                    <th rowspan="2" style="text-align: center">الصنف</th>
                    <th colspan="2" style="text-align: center">جديد</th>
                    <th colspan="2" style="text-align: center">مستعمل</th>
                    <th colspan="2" style="text-align: center">ضمان</th>
                    <th rowspan="2" style="text-align: center">العمولة</th>
                    <th rowspan="2" style="text-align: center">الإجراء</th>
                  </tr>
                  <tr>
                    <th style="text-align: center">كاش</th>
                    <th style="text-align: center">قسط</th>
                    <th style="text-align: center">كاش</th>
                    <th style="text-align: center">قسط</th>
                    <th style="text-align: center">كاش</th>
                    <th style="text-align: center">قسط</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class='odd gradeX' v-for='record in records' :key='record.id'>
                    <td align='right'>{{record.item}}</td>
                    <td align='center'>{{record.price}}</td>
                    <td align='center'>{{record.installment_price}}</td>
                    <td align='center'>{{record.used_price}}</td>
                    <td align='center'>{{record.used_installment_price}}</td>
                    <td align='center'>{{record.warranty_price}}</td>
                    <td align='center'>{{record.warranty_installment_price}}</td>
                    <td align='center'>{{record.del_commission}}</td>
                    <td align='center'>
                      <vue-element-loading size='32' :active='isLoadingDelete' spinner='bar-fade-scale' color='#A4A4A4'/>
                      <button @click='showForm(record)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#myModal'>تعديل</button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /.table-responsive -->
            </div>
            <!-- /.panel-body -->
          </div>
          <!-- /.panel -->
        </div>
        <!-- /.col-lg-12 -->
      </div>
    </div>
    <!-- Modal -->
    <div class='modal fade' id='myModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
      <div class='modal-dialog  modal-sm'>
        <div class='modal-content'>
          <div class='modal-header'>
            <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
            <h4 class='modal-title' id='myModalLabel'>{{title}}</h4>
          </div>
          <form role='form'>
            <div class='modal-body'>
              <div class='alert alert-danger alert-dismissable' v-if='errorShow'>
                <ul v-if='validationErrors'>
                  <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                </ul>
              </div>
              <div class='alert alert-success alert-dismissable' v-if='successShow'>
                {{success}}
              </div>
              <fieldset>
                <div class='form-group col-lg-12 col-sm-12' style="margin: 0px">
                  <label>جديد:</label>
                  </div>
                  <div class='form-group col-lg-12 col-sm-12' style="margin: 0px">
                  <div class='form-group col-lg-6 col-sm-6' style="padding: 0px 1px;margin: 0px">

                  <div class="form-group input-group">
                      <span class="input-group-addon">كاش</span>
                      <input style="padding: 5px 5px" @keypress="isNumber($event)" v-model='record.price' class='form-control' name='price' type='text'>
                  </div>
                </div>
                <div class='form-group col-lg-6 col-sm-6' style="padding: 0px 1px;margin: 0px">
                  <div class="form-group input-group">
                      <span class="input-group-addon">قسط</span>
                      <input style="padding: 5px 5px"  @keypress="isNumber($event)" v-model='record.installment_price' class='form-control' name='price' type='text'>
                  </div>
                </div>
              </div>
              <div class='form-group col-lg-12 col-sm-12' style="margin: 0px">
                <label>مستعمل:</label>
                </div>
                <div class='form-group col-lg-12 col-sm-12' style="margin: 0px">
                <div class='form-group col-lg-6 col-sm-6' style="padding: 0px 1px;margin: 0px">

                <div class="form-group input-group">
                    <span class="input-group-addon">كاش</span>
                    <input style="padding: 5px 5px" @keypress="isNumber($event)" v-model='record.used_price' class='form-control' name='price' type='text'>
                </div>
              </div>
              <div class='form-group col-lg-6 col-sm-6' style="padding: 0px 1px;margin: 0px">
                <div class="form-group input-group">
                    <span class="input-group-addon">قسط</span>
                    <input style="padding: 5px 5px"  @keypress="isNumber($event)" v-model='record.used_installment_price' class='form-control' name='price' type='text'>
                </div>
              </div>
            </div>
            <div class='form-group col-lg-12 col-sm-12' style="margin: 0px">
              <label>ضمان:</label>
              </div>
              <div class='form-group col-lg-12 col-sm-12' style="margin: 0px">
              <div class='form-group col-lg-6 col-sm-6' style="padding: 0px 1px;margin: 0px">

              <div class="form-group input-group">
                  <span class="input-group-addon">كاش</span>
                  <input style="padding: 5px 5px" @keypress="isNumber($event)" v-model='record.warranty_price' class='form-control' name='price' type='text'>
              </div>
            </div>
            <div class='form-group col-lg-6 col-sm-6' style="padding: 0px 1px;margin: 0px">
              <div class="form-group input-group">
                  <span class="input-group-addon">قسط</span>
                  <input style="padding: 5px 5px"  @keypress="isNumber($event)" v-model='record.warranty_installment_price' class='form-control' name='price' type='text'>
              </div>
            </div>
          </div>
          <div v-show="record.is_contract" class='form-group col-lg-12 col-sm-12'>
            <div class="form-group input-group">
                <span class="input-group-addon">عمولة المفوض</span>
                <input  @keypress="isNumber($event)" v-model='record.del_commission' class='form-control' name='price' type='text'>
            </div>
          </div>
              </fieldset>
            </div>
            <div class='modal-footer'>
              <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
              <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
              <button v-show= "isEnable" @click='saveData' type='button' class='btn btn-primary'>حفظ</button>
            </div>
          </form>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <!-- /.container-fluid -->
  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'ItemPrices',
  data () {
    return {
      isEnable: true,
      validationErrors: '',
      records: {},
      record: {},
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      branches: [],
      branch: '',
      title: ''
    }
  },
  created () {
    this.branch = localStorage.getItem('BrancheID')
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.GetData()
  },
  methods: {
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getItemPrices', {
        token: localStorage.getItem('token'),
        branch: this.branch
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    // ===================================================
    isNumber: function (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    // ===================================================
    showForm (recID) {
      this.errorShow = false
      this.successShow = false
      this.isEnable = true
      this.error = ''
      this.title = 'تعديل بيانات سجل'
      this.record = recID
    },
    // ===================================================
    saveData () {
      this.isLoadingSave = false
      axios.post(this.$apiURL + 'saveItemPrices', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        branch_id: this.branch,
        item_id: this.record.item_id,
        price: this.record.price,
        installment_price: this.record.installment_price,
        warranty_price: this.record.warranty_price,
        del_commission: this.record.del_commission,
        used_price: this.record.used_price,
        redemption: this.record.redemption,
        used_installment_price: this.record.used_installment_price,
        warranty_installment_price: this.record.warranty_installment_price
      })
        .then(res => {
          this.isLoadingSave = false
          this.records = res.data
          this.isEnable = false
          this.success = 'تم الحفظ بنجاح'
        })
        .catch(err => {
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/purchases/ItemPrices.vue